<h1 mat-dialog-title>Change Language</h1>

<div mat-dialog-content>
  <p>Supported languages</p>

  @for (lang of supportedLanguages; track lang) {
    <button
      (click)="selectLanguage(lang)"
      mat-raised-button
      mat-dialog-close
      class="full-width">
      <span></span>
      {{lang.name}}
      @if (lang.default) {
        <span> (Default)</span>
      }
    </button>
  }
</div>